import { Form, Input } from "@arco-design/web-react"
import { useEffect } from "react";

const FormItem = Form.Item;
const TextArea = Input.TextArea;

export const EmailTemplates = ({ value, onChange }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        const values = { ...value }
        form.setFieldsValue(values);
    }, [form, value]);

    const handleFormChange = () => {
        const values = form.getFieldsValue();
        onChange?.({ ...value, ...values });
    };

    return (
        <Form form={form} colon
            onChange={handleFormChange}
            labelCol={{ span: 3 }} wrapperCol={{ span: 21 }}>
            <FormItem label="PO Templates" field="poTemplate">
                <TextArea style={{ minHeight: 200 }} />
            </FormItem>
            <FormItem label="Receipt Templates" field="receiptTemplate" hidden>
                <TextArea style={{ minHeight: 200 }} />
            </FormItem>
            <FormItem label="Bill Templates" field="billTemplate" hidden>
                <TextArea style={{ minHeight: 200 }} />
            </FormItem>
            <FormItem label="SO Templates" field="soTemplate">
                <TextArea style={{ minHeight: 200 }} />
            </FormItem>
            <FormItem label="Pick Order Templates" field="pickOrderTemplate">
                <TextArea style={{ minHeight: 200 }} />
            </FormItem>
            <FormItem label="SO Fulfillment Templates" field="soFulfillmentTemplate">
                <TextArea style={{ minHeight: 200 }} />
            </FormItem>
            <FormItem label="Invoice Templates" field="invoiceTemplate">
                <TextArea style={{ minHeight: 200 }} />
            </FormItem>
            <FormItem label="Account Statement Templates" field="accountStatementTemplate">
                <TextArea style={{ minHeight: 200 }} />
            </FormItem>
        </Form>

    )
}